import { Link } from '@tanstack/react-router';
import { useEffect, useId, useRef } from 'react';
import { CONSENT_TEXT } from '../lib/consent';
import styles from './ConsentCheckbox.module.css';

interface ConsentCheckboxProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  // Why the box must be ticked; it takes focus whenever this is set again.
  error?: string | null;
}

export function ConsentCheckbox({ checked, onChange, error = null }: ConsentCheckboxProps) {
  const errorId = useId();
  const box = useRef<HTMLInputElement>(null);
  useEffect(() => {
    if (error !== null) box.current?.focus();
  }, [error]);
  return (
    <div className={styles.consent}>
      <label className={styles.label}>
        <input
          ref={box} type="checkbox" className={styles.box} checked={checked} onChange={(e) => onChange(e.currentTarget.checked)}
          aria-required="true" aria-invalid={error !== null || undefined} aria-describedby={error !== null ? errorId : undefined}
        />
        <span>{CONSENT_TEXT}</span>
      </label>
      {error !== null && <p id={errorId} role="alert" className="alert-hot">{error}</p>}
      {/* A new tab, so a half-filled sign-up form survives reading the policy. */}
      <Link to="/privacy" target="_blank" rel="noopener" className={styles.policy}>
        HOW PAINPAL USES YOUR DATA <span aria-hidden="true">↗</span><span className="sr-only">(opens in a new tab)</span>
      </Link>
    </div>
  );
}
